import apiUrl from 'common/api-url';

export const downloadFile = (year: string) => {
  const downloadLink = document.createElement('a');
  downloadLink.href = apiUrl('DAC7_REPORT_BY_YEAR', { supplierId: App.getSupplierId(), year });
  downloadLink.target = '_blank';
  downloadLink.rel = 'noreferrer';
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};
